import { isEmpty } from 'lodash'

export const createFormData = (dataObject) => {
  const formData = new FormData()

  if (isEmpty(dataObject)) {
    throw new Error ('createFormData Error')
  }

  for (const key in dataObject) {
    formData.append(key, dataObject[key])
  }
  
  return formData
}
